<label for="">Upload single file</label><br />
<input type="file" (change)="upload($event)" />
<br />
<label for="">Upload multiple files</label><br />
<input type="file" (change)="uploadMultiple($event)" multiple />
